import React from "react"
import { Link, navigate, useStaticQuery} from "gatsby"
import { MDXRenderer } from "gatsby-plugin-mdx"
import { MDXProvider } from "@mdx-js/react"
import { motion } from "framer-motion"
import Typed from "react-typed"
import {ArrowDown} from "../icons/arrow-down-icon"
// import Link from "../link"

// function HeroLink ({heroColor, activeClassName = "active", ...props}) {
//   return (
//     <Link
//       activeClassName={activeClassName}
//       partiallyActive={true}
//       {...props}
//       />
//   )
// }

function Hero ({ content }) {
  const { frontmatter, body } = content[0].node
  // const data = useStaticQuery(graphql`
  //   query HeroQuery {
  //     site {
  //       siteMetadata {
  //         author {
  //           name
  //           minibio
  //         }
  //         social {
  //           twitter
  //         }
  //       }
  //     }
  //   }
  // `)

  // // Set these values by editing "siteMetadata" in gatsby-config.js
  // const author = data.site.siteMetadata?.author
  // const social = data.site.siteMetadata?.social
  const variants = {
    hidden: {
      opacity: 0,
      x: -10,
    },
    display: {
      opacity: 1,
      x: 0,
    },
  }
  return (
    <MDXProvider
      components={{
        p: props => (
          <p
            {...props}
            className="text-lg md:text-2xl lg:text-3xl font-normal leading-relaxed tracking-tight"
          />
        ),
        em: props => (
          <em
            {...props}
            className="text-lg md:text-2xl font-normal leading-relaxed tracking-tight text-gray-500"
          />
        ),
      }}
    >
      <section
        id="hero"
        className="flex flex-col items-start justify-start lg:justify-center py-44 sm:py-48 lg:py-0 md:min-h-screen max-w-screen bg-hero-pattern bg-no-repeat bg-contain bg-local bg-blue-100 dark:bg-gray-900 bg-left-bottom md:bg-bottom-right bg-blend-luminosity" alt="Danniel Hansel"
      >
        <div className="w-full h-full">
          <div className="container mx-auto px-4">
            <div className="select-none flex flex-col items-start lg:items-end ">
              <motion.h1
                className="font-mono font-light text-md md:text-xl lg:text-2xl  text-secondary-text"
                variants={variants}
                initial="hidden"
                animate="display"
                transition={{ delay: 0.8 }}
              >
                {frontmatter.intro}
              </motion.h1>
              <motion.h2
                className="font-body2 font-bold text-4xl sm:text-5xl md:text-6xl lg:text-7xl  text-transparent bg-clip-text bg-gradient-to-r from-blue-800 via-blue-500 to-gray-900 dark:from-gray-700 dark:via-gray-300 dark:to-white mb-5"
                variants={variants}
                initial="hidden"
                animate="display"
                transition={{ delay: 1.2 }}
              >
                {frontmatter.title}
              </motion.h2>
              <motion.p
                // className="font-body1 text-xl md:text-2xl lg:text-3xl font-bold  text-secondary-text mb-10"
                className="font-body1 text-lg md:text-xl lg:text-3xl font-light md:font-normal leading-relaxed tracking-tight text-secondary-text mb-10"
                variants={variants}
                initial="hidden"
                animate="display"
                transition={{ delay: 1.4 }}
              >
                <Typed
                  strings={[
                    // "Hi,", "my ", "name ", "is"
                    // 'My strings are: <i>strings</i> with', 'My strings are: <strong>HTML</strong>', 'My strings are: Chars &times; &copy;'
                    "",
                    "I'm a <b>software engineer</b>^1000 based in Dallas,^1000 Texas."
                  ]}
                  // typeSpeed={40}
                  // backSpeed={50}
                  fadeOut
                  typeSpeed={40}
                  backSpeed={0}
                  cursorChar= '_'
                  smartBackspace
                  // shuffle
                  // loop
                />
              </motion.p>
              <motion.div
              className="flex flex-row justify-start items-start space-x-4 mb-16"
                variants={variants}
                initial="hidden"
                animate="display"
                transition={{ delay: 1.6 }}
              >
                <button 
                  type="button" 
                  onClick={() => { navigate("/#featuredPosts")}}
                  aria-label="read my blogs"
                  className='relative inline-block w-auto px-6 py-4 md:px-11 md:py-6 text-md md:text-lg lg:text-xl cursor-pointer focus:outline-none font-bold shadow-xl shadow-sky-200/80 dark:shadow-gray-600/20 rounded-full transition duration-300 ease-in-out hover:-translate-y-1 bg-gradient-to-b from-sky-200 to-sky-100 hover:from-sky-100 hover:to-sky-200 dark:from-gray-700 dark:via-gray-900 dark:to-black dark:hover:from-gray-600 dark:hover:via-gray-800 dark:hover:to-gray-900'>
                    <span className="whitespace-nowrap text-quarternary ">Read the blog</span>    
                </button>
                <Link 
                  to='/contact'
                  aria-label="contact me"
                  // activeClassName="none"
                  >
                    <button className='relative inline-block w-auto px-6 py-4 md:px-11 md:py-6 text-md md:text-lg lg:text-xl cursor-pointer focus:outline-none font-bold shadow-xl shadow-blue-500/40 dark:shadow-teal-100/10 rounded-full transition duration-300 ease-in-out hover:-translate-y-1 bg-gradient-to-r from-sky-400 to-blue-500 hover:from-sky-300 hover:to-blue-400 dark:from-rose-100 dark:to-teal-100 dark:hover:from-rose-50 dark:hover:to-teal-50'>
                      <span className="whitespace-nowrap text-primary">Get in touch</span>
                    </button>
                </Link>
              </motion.div>
              <motion.div 
                className="hidden md:flex items-center justify-start text-secondary-text hover:text-quarternary  "
                variants={variants}
                initial="hidden"
                animate="display"
                transition={{ delay: 1.6 }}
                onClick={() => { navigate("#about")}}>
                {/* <Link to="/#about"> */}
                  <button class="flex flex-cols-2 space-x-6 items-center justify-center">
                    <ArrowDown />
                    <span className="font-body1 relative text-2xl font-semibold leading-relaxed tracking-tight ">Learn more about Danniel</span>
                </button> 
                {/* </Link> */}
              </motion.div>
            </div>
          </div>
        </div>
      </section>
    </MDXProvider>
  )
}

export default Hero
